import { GatsbyLinkProps, Link as GatsbyLink } from 'gatsby'
import * as React from 'react'
import { formatPath, urlStringToArray } from '../../lib/utils/internalLinks'

type CustomLinkWithHref<T> = GatsbyLinkProps<T> & {
  children?: React.ReactNode
  href: string
  to?: string
}

type CustomLinkWithTo<T> = GatsbyLinkProps<T> & {
  children?: React.ReactNode
  to: string
  href?: string
}

type CustomLinkProps<T> = CustomLinkWithHref<T> | CustomLinkWithTo<T>

// Adopted from here
// https://www.charpeni.com/blog/wrapping-gatsbys-link-with-typescript
function CustomLink<TState>({
  href,
  to,
  activeClassName = undefined,
  activeStyle = undefined,
  partiallyActive = undefined,
  ...rest
}: React.PropsWithoutRef<CustomLinkProps<TState>>) {
  const url = href || to

  const isExternal = url?.startsWith(`http://`) || url?.startsWith(`https://`) || url?.startsWith(`//`)

  // just for the purpose to make sure, that we dont use the "router" for documentations
  // docs are external pages
  if (urlStringToArray(url) && urlStringToArray(url)[0] === 'docs') {
    return <a {...rest} href={formatPath(url)} />
  }

  if (rest.target === '_blank') {
    return <a {...rest} href={url} rel="noopener noreferrer" target="_blank" />
  }

  if (isExternal) {
    return <a {...rest} href={url} target='_blank' />
  }

  return (
    <GatsbyLink<TState>
      to={formatPath(url)}
      activeClassName={activeClassName}
      activeStyle={activeStyle}
      partiallyActive={partiallyActive}
      {...rest}
    />
  )
}

export default CustomLink
